module.exports = __webpack_public_path__ + "img/NAV_logo.d6d3076c.svg";